/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Modified_LabelInputs */



/**
* | output |
* | --- |
* | "Modified:" |
*
* @param {Explorer_Thumbnail_Modified_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_modified_label = /** @type {((inputs?: Explorer_Thumbnail_Modified_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Modified_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifie :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geändert:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modificato:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменено:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modificado:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修改的：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संशोधित:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modificado:")
	return /** @type {LocalizedString} */ ("Modified:")
});